export default "__VITE_ASSET__Byeurw2___"